<template>
    <div>
        <navView :isSelect="isSelect" />
        <div class="wrap">
            <div class="download">
                <el-input placeholder="请输入task_id下载文件" v-model="taskId" class="input">
                    <el-button slot="append" icon="el-icon-download" @click="download"></el-button>
                </el-input>
            </div>
            <upload />
        </div>
        <img class="img" src="../assets/images/img1.png" alt="">
        <footerView />
    </div>
</template>

<script>
import navView from '../components/nav.vue';
import footerView from '../components/footer.vue';
import upload from '../components/upload.vue';
import { getList } from '@/api/api'
import axios from 'axios'
export default {
    components: {
        upload, navView, footerView
    },
    data() {
        return {
            taskId: '',
            isSelect: 0
        }
    },
    created() {
        this.isSelect = this.$route.query.index
    },
    methods: {
        download() {
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            axios({
                url: 'http://43.136.108.67:5000/download',
                method: 'GET',
                responseType: 'blob',
                params: { task_id: this.taskId },
            }).then(response => {
                loading.close()
                let blob = new Blob([response.data], { type: 'application/zip' });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = 'filename.zip'; // 设置下载的文件名，确保指定 .zip 后缀
                a.click();
                window.URL.revokeObjectURL(url);
            });
        }
    }
}

</script>

<style scoped lang="scss">
@media only screen and (max-width: 750px) {
    .wrap {
        padding: 60px 10px 10px 10px;

        .download {
            padding: 10px;
        }

        .input {
            width: 100%;
        }
    }
}

@media only screen and (min-width: 751px) {
    .wrap {
        padding: 160px 60px 60px;

        .download {
            padding: 30px;
        }

        .input {
            width: 60%;
        }
    }
}

.img {
    width: 90%;
    display: block;
    margin: 5% auto;
}
</style>